import { render, staticRenderFns } from "./ButtonIconTextModelB.vue?vue&type=template&id=17a575e4"
import script from "./ButtonIconTextModelB.vue?vue&type=script&lang=js"
export * from "./ButtonIconTextModelB.vue?vue&type=script&lang=js"
import style0 from "./ButtonIconTextModelB.vue?vue&type=style&index=0&id=17a575e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports